import { patientBaseModel } from './crud';
import { useCreateMutation } from '../../CRUD';
import { axiosService } from '../../services/axiosService';

type TUsePatientVerifyParams = {
  patientId: string;
  code: string;
};

type TUsePatientVerifyResponse = { token: string };

const { keys } = patientBaseModel;

export const usePatientVerify = () => {
  const mutationFn = async ({ patientId, code }: TUsePatientVerifyParams) => {
    const { data } = await axiosService.post(
      `${keys.basicUrlPath}/${patientId}/verify`,
      { code },
    );

    return data as TUsePatientVerifyResponse;
  };

  return useCreateMutation<TUsePatientVerifyResponse, TUsePatientVerifyParams>(
    keys.all,
    mutationFn,
  );
};
